import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar from '@fullcalendar/react';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';

import DatePickerField from 'CommonComponents/DatePickerField';

export default function SummaryScheduleCalendarElement(props) {
    const [tableWidth, setTableWidth] = useState(500);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        $('.content').css('position', 'relative').css('overflow-y', 'scroll');
        setMounted(true);
    }, []);

    useEffect(() => {
        let tWidth = tableWidth;
        if (props.resources.length > 4) {
            tWidth = (props.resources.length + 1) * 100;
        }

        setTableWidth(tWidth);
    }, [props.resources]);

    const renderDatePicker = () => {
        const toolbarElement = document.querySelector('.fc-toolbar-chunk:last-child');

        if (toolbarElement) {
            return ReactDOM.createPortal(
                <DatePickerField
                    name="currentDate"
                    className={'tw-border-0 text-input'}
                    value={props.date}
                    onChange={props.changedateDatepickerDate}
                    valueFormat={'yyyy-MM-dd'}
                    dateFormat={'dd/MM/yyyy'}
                    min={props.minDate}
                    max={props.maxDate}
                />,
                toolbarElement,
            );
        }
        return null;
    };

    return (
        <div>
            <style nonce={window.nonceKey}>
                {`
                    .fc-view {
                        overflow-x: auto;
                    }

                    .fc-view > table {
                        min-width: 100%;
                        width: ${tableWidth}px !important;
                    }

                    .fc-time-grid .fc-slats {
                        z-index: 4;
                        pointer-events: none;
                    }

                    .fc-scroller.fc-time-grid-container {
                        overflow: initial !important;
                    }

                    .fc-timegrid-axis {
                        position: sticky;
                        left: 0;
                    }
                    .react-datepicker-popper {
                        z-index: 100;
                    }
                `}
            </style>

            <FullCalendar
                ref={props.calendarRef}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: '',
                }}
                plugins={[resourceTimeGridPlugin, interactionPlugin]}
                initialDate={props.initialDate}
                initialView="resourceTimeGridDay"
                resources={(fetchInfo, successCallback) => successCallback(props.resources)}
                events={props.events}
                datesSet={props.dateChangedHandler}
                height={750}
                stickyHeaderDates={true}
                eventDidMount={(info) => {
                    if (info.event.extendedProps.isMedal) {
                        $(info.el)
                            .find('.fc-event-main-frame')
                            .prepend(`<div class="tw-flex tw-justify-end"><img src="/images/event-info/gold.svg" class="tw-w-6 tw-h-6" /></div>`);
                    }

                    if (info.event.extendedProps.tooltip) {
                        $(info.el).data({
                            'popper-toggle': 'tooltip',
                            trigger: 'hover',
                            placement: 'auto',
                            html: true,
                            content: info.event.extendedProps.tooltip,
                        });

                        const triggerEvents = ['mouseenter', 'focus'];
                        triggerEvents.forEach((event) => {
                            info.el.addEventListener(event, () => window.initializeIndividualTooltip(info.el, 'body'));
                        });
                    }
                }}
            />
            {mounted && renderDatePicker()}
        </div>
    );
}
